import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortestName' })
export class CompetencyShortNamePipe implements PipeTransform {
  transform(competency: any): string {
    return competency.shortName ? competency.shortName : competency.value;
  }
}
